/*!
 * devextreme-angular
 * Version: 26.1.5
 * Build date: Fri Sep 11 2026
 *
 * Copyright (c) 2012 - 2026 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/DevExtreme
 */

/* tslint:disable:max-line-length */


import {
    Component,
    OnInit,
    OnDestroy,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';





import {
    DxIntegrationModule,
    NestedOptionHost,
} from 'devextreme-angular/core';
import { NestedOption } from 'devextreme-angular/core';


@Component({
    selector: 'dxo-select-box-field-addons',
    template: '',
    styles: [''],
    imports: [ DxIntegrationModule ],
    providers: [NestedOptionHost]
})
export class DxoSelectBoxFieldAddonsComponent extends NestedOption implements OnDestroy, OnInit  {
    @Input()
    get afterTemplate(): any {
        return this._getOption('afterTemplate');
    }
    set afterTemplate(value: any) {
        this._setOption('afterTemplate', value);
    }

    @Input()
    get beforeTemplate(): any {
        return this._getOption('beforeTemplate');
    }
    set beforeTemplate(value: any) {
        this._setOption('beforeTemplate', value);
    }


    protected get _optionPath() {
        return 'fieldAddons';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }


    ngOnInit() {
        this._addRecreatedComponent();
    }

    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }


}

@NgModule({
  imports: [
    DxoSelectBoxFieldAddonsComponent
  ],
  exports: [
    DxoSelectBoxFieldAddonsComponent
  ],
})
export class DxoSelectBoxFieldAddonsModule { }
